import { compose } from 'recompose'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { APPOINTMENT_FORM_NAME } from 'constant'
import { getAppointments } from 'selectors/getAppointments'
import validate from './validate'
import VehicleSelector from './VehicleSelector'

const shouldValidate = () => true

export default compose(
  connect(state => ({
    isTrailer: getAppointments(state).isTrailer
  })),
  reduxForm({
    validate,
    shouldValidate,
    form: APPOINTMENT_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(VehicleSelector)
